import styled from 'styled-components'

// Library Components
import { TabPane } from 'reactstrap'

export const TabPaneWrapper = styled(TabPane)``
